export default __webpack_public_path__ + "static/media/airport_project.f41256fa.jpg";